import React from "react";

export const GlobalContext = React.createContext();
export const GlobalActionsContext = React.createContext(null);
